export function getDatePart(value) {
  if (!value) return '';

  const match = String(value).trim().match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : '';
}

export function getDateTimeInputValue(value) {
  if (!value) return '';

  const match = String(value).trim().match(/^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})/);
  return match ? `${match[1]}T${match[2]}` : '';
}

export function toPocketBaseDateTime(value) {
  if (!value) return '';

  const normalized = String(value).trim().replace('T', ' ').replace(/Z$/, '');
  const match = normalized.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})(?::\d{2}(?:\.\d+)?)?$/);

  return match ? `${match[1]} ${match[2]}:00` : normalized;
}

export function formatDateTime(value) {
  return getDateTimeInputValue(value).replace('T', ' ');
}
